import WebInterface from './interface/web';
import AppInterface from './interface/app';
import SsoInterface from './interface/sso';
import AuthInterface from './interface/auth';
import { encryptParams } from './utils';
import { TypeInitProps } from './types';
export const WebInterfaceSdk = WebInterface;
export const AppInterfaceSdk = AppInterface;
export const SsoInterfaceSdk = SsoInterface;
export const AuthInterfaceSdk = AuthInterface;

class AccountSdk {
  constructor(props: TypeInitProps) {
    const { scope = 'web' } = props;
    switch (scope) {
      case 'web': {
        return new WebInterface(props);
      }
      case 'app': {
        return new AppInterface(props);
      }
      case 'sso': {
        return new SsoInterface(props);
      }
      case 'auth': {
        return new AuthInterface(props);
      }
      default: {
        return new WebInterface(props);
      }
    }
  }
}

const SdkType: any = {
  web: WebInterface,
  app: AppInterface,
  sso: SsoInterface,
  auth: AuthInterface,
};

const SdkInstance: any = {
  web: null,
  app: null,
  sso: null,
  auth: null,
};

class AccountSdkFactory {
  static createAccountSdk(type: any, config: TypeInitProps) {
    const targetType = SdkType[type] || SdkType.web;
    if (SdkInstance[type]) {
      return SdkInstance[type];
    }
    SdkInstance[type] = AccountSdkFactory.create(targetType, config);
    return SdkInstance[type];
  }

  static create<T>(
    Type: new (config: TypeInitProps) => T,
    config: TypeInitProps
  ): T {
    return new Type(config);
  }
}
const { createAccountSdk } = AccountSdkFactory;
export const AccountSdkInstance = createAccountSdk;
export default AccountSdk;
export { encryptParams };
